import { ref, readonly, computed } from 'vue';

// Global refs that can be shared across components
const searchResultsContainer = ref(null);
const searchResults = ref([]);

export function useSearchResultsContainer() {
  const setContainer = (element) => {
    searchResultsContainer.value = element;
  };

  const setResults = (results) => {
    searchResults.value = results;
  };

  const getContainerHeight = () => {
    if (searchResultsContainer.value) {
      return searchResultsContainer.value.offsetHeight;
    }
    return 400; // fallback
  };

  const hasResults = computed(() => searchResults.value.length > 0);
  const resultsCount = computed(() => searchResults.value.length);

  return {
    searchResultsContainer: readonly(searchResultsContainer),
    searchResults: readonly(searchResults),
    setContainer,
    setResults,
    getContainerHeight,
    hasResults,
    resultsCount,
  };
}
